module.exports = __webpack_public_path__ + "static/media/pin.2b2e2c83.svg";